/* global globalThis */
import React, { useEffect, useState } from "react";
import { MyCoursesCard } from "../MyCourseCard/MyCoursesCard";
import "../CoursesList/coursesList.scss";
import TestSeriesLoader from "../common/loaders/TestSeriesLoader";
import { useHistory } from "react-router-dom";
import { useDebounce, useTranslations } from "sdk/custom-hooks";
import { useDispatch, useSelector } from "react-redux";
import { useAutoClearSearchQuery, useSearchQuery } from "../../services/SearchQueryContext";
import NotFound from "../../pages/NotFound";
import { ReactComponent as SearchIcon } from "../../assets/images/search.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/close.svg";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { certificateListAction } from "sdk/actions/certificateAddResponse";
import { Box, Button, Input, makeStyles } from "@material-ui/core";
import { getUserCourse } from "sdk/actions";

function MyCoursesList() {
  useAutoClearSearchQuery();
  const history = useHistory();
  const selectedTab = 1;
  const user = useSelector((state) => state.user);
  const userId = user?.user?._id  ? user?.user?._id : user?._id;
  const { searchQuery, setSearchQuery } = useSearchQuery();
  const t = useTranslations();
  const dispatch = useDispatch();
  const location = useLocation();
  const quizMode = useSelector(state => state.practiceQuizzes.quizMode);
  const slug = useSelector(state => state.practiceQuizzes.slug);
  const courseId = useSelector(state => state.filteredCourseList.courseId);
  const [certificateListing, setCertificateListing] = useState([]);
  const isFirefox = typeof InstallTrigger !== "undefined";
  const classes = useStyles(isFirefox);
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);

  const userCoursesState = useSelector(state => state.userCourses);
  let debouncedSearch = useDebounce(searchQuery, 500);
  const { isLoading, totalCount } = userCoursesState;
  const limit = 20;
  const [hasMoreData, setHasMoreData] = useState(true);
  const [ contentData, setContentData ] = useState([]);

  function clearField(searchQuery) {
    if (searchQuery?.length) setSearchQuery("");
  }

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - scrollTop === clientHeight && hasMoreData) {
      const skip = contentData?.length || 0;
      if (limit <= totalCount) {
        fetchCoursesOnSearch(userId, skip, limit, debouncedSearch);
      }
    }
  };

  useEffect(() => {
    if (userId !== undefined) {
      setHasMoreData(true); // Reset this on new search
      fetchCoursesOnSearch(userId, 0, limit, debouncedSearch);
    }
  }, [debouncedSearch]);

  const fetchCoursesOnSearch = async (userId, skip = 0, limit = 20, search = "") => {
    try {
      const res = await Promise.resolve(dispatch(getUserCourse(userId, skip, limit, search)));

      const newData = res?.data[0]?.courses || [];
      const sortedData = newData.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
      if (skip === 0) {
          setContentData(sortedData);
      } else {
          setContentData(prev => [...prev, ...sortedData]); // Infinite scroll
      }
      if (newData.length === 0 || newData.length < limit) { // If no data returned, prevent calling api again and again
          setHasMoreData(false);
      }
    } catch (error) {
      console.error("Failed to fetch course list:", error);
    }
  };

  useEffect(() => {
    getCertificateListingData();
    clearField();
  }, []);

  useEffect(() => {
    if (
      location?.state === undefined ||
      location?.state?.params === `/quiz/${quizMode}/${slug}/${courseId}`
    ) {
      const screenWidth = globalThis.innerWidth;
      if (screenWidth > 959) {
        history.replace("/dashboard", { params: globalThis.location.pathname });
      }
    }
  }, []);

  const getCertificateListingData = async () => {
    try {
      dispatch(certificateListAction()).then((res) => {
        if (Array.isArray(res?.data)) {
          setCertificateListing(res?.data);
        }
      });
    } catch (error) {
      console.error(error.message);
    }
  };

  function renderCourseResults() {
    if (isLoading && contentData?.length === 0) {
      return renderLoader();
    }

    if (contentData?.length > 0) {
      return (
        <Box className="card-view-new test-series-new ">
          {contentData.map((data, index) => (
            <MyCoursesCard
              key={data?._id || data?.id || `${data?.slug || "course"}-${index}`}
              testData={data}
              certificateListing={certificateListing}
              settingsData={settingsData}
            />
          ))}
        </Box>
      );
    }

    if (!isLoading && contentData?.length === 0) {
      return <Box className={classes.centerAlign}><NotFound/></Box>;
    }

    return null;
  }

  function renderList() {
    return (
      <React.Fragment>
        {selectedTab === 1 && (
          <Box className="main-div mobile-padding">
            <Box className="course-search-box">
              <Input
                className="inner-search-box"
                style={{ border: "none" }}
                type="text"
                placeholder={t("Search")}
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
              />
              <Box className="course-search-img-box">
                {searchQuery.length ? (
                  <Button
                    onClick={() => clearField(searchQuery)}
                    style={{ border: "none" }}
                  >
                    <CrossIcon className="cross-icon" alt="Cross Icon" />
                  </Button>
                ) : (
                  <SearchIcon className="search-icon" alt="Search Icon" />
                )}
              </Box>
            </Box>
            <Box className="card-list-div" onScroll={handleScroll}>
              {renderCourseResults()}
            </Box>
          </Box>
        )}
      </React.Fragment>
    );
  }

  function renderLoader() {
    //we will show three cards to fill this space.
    return (
      <Box className="card-view test-series">
        {Array.from({ length: 8 }, (_, index) => (
          <TestSeriesLoader key={index} />
        ))}
      </Box>
    );
  }

  return (
    <React.Fragment>
      {renderList()}
    </React.Fragment>
  );
}

const useStyles = makeStyles(() => ({
  centerAlign: (isFirefox) => ({
    textAlign: isFirefox ? "-moz-center" : "-webkit-center",
  }),
}));
export default MyCoursesList;
